import  React from 'react';
import _ from 'underscore';

export const Input = ({allowPlusSign, label, onInputChange, value, minLength, maxLength, lengthText = "", className, valid, invalid}) => {
  let labelItem;
  if(minLength || maxLength){
    let icon;
    if(valid){
      icon = (<div className="valid-icon"/>);
    }
    labelItem = (
      <label className="input-label">
        {icon}
        {label}
        <span className="validity-label">{`( ${minLength != maxLength ? minLength + '-' : ''}${maxLength} ${lengthText} )`}</span>
      </label>
    );
  } else {
    labelItem = (
      <label className="input-label">
        {label}
      </label>
    );
  }

  const classItem = ("input" + (value != '' ? " is-not-empty" : "" ));

  return(
    <div className={className + " input-item"}>
      <NumberInput
        allowPlusSign={allowPlusSign}
        className={classItem}
        onInputChange={ onInputChange }
        value={ value }
        maxLength={ maxLength }
        valid={valid}
        invalid={invalid}
      />
      <InputBoxes
        minLength={minLength}
        maxLength={maxLength}
      />
      {labelItem}
    </div>

  );
};

const NumberInput = ({allowPlusSign, className, onInputChange, value, maxLength, valid, invalid}) => {

  const validateNumberInputKeyPress = (evt, valLength) => {
    const charCode = evt.charCode;

    if (allowPlusSign) {
      if(charCode != 0 && ((charCode < 48 && charCode != 43) || charCode > 57)) {
        evt.preventDefault();
      }
    } else {
      if(charCode != 0 && (charCode < 48 || charCode > 57)){
        evt.preventDefault();
      }
    }

  };

  const validateNumberInput = (input) => {

    if (allowPlusSign) {
      if(/^[+]?\d*$/.test(input) || input === ''){
        onInputChange(input);
      }
    } else {
      if(/^\d+$/.test(input) || input === ''){
        onInputChange(input);
      }
    }
  };

  return(
      <input
        className={className + (valid ? ' valid' : (invalid ? ' invalid' : ''))}
        type="tel"
        onKeyPress={(event) => validateNumberInputKeyPress(event, value.length)}
        onInput={ ({target}) => validateNumberInput(target.value) }
        onChange={() => {}}
        value={ value }
        id="numInput"
        maxLength={maxLength}
      />
  );
};

//Shows grey boxes behind each character.
//Input font must be monospaced, in order to keep characters inside the boxes.
const InputBoxes = ({minLength, maxLength}) => {

  let inputBoxes = _.range(maxLength).map((val, i) => {
    let line;

    //shows line between every third character
    if(i !== 0 && !(i%3)){
      line = (<span className="line">-</span>);
    }

    //moves boxes so that between every third box is larger space, so that the line can fit between the boxes.
    let left = "-2px";
    if(!((i-1)%3)){
      left = "-1px";
    }
    else if(!(i%3)){
      left = "0px";
    }

    let boxStyle = {
      "left": left
    };

    return(
      <div
        key={i}
        className={"input-box" + (i >= minLength ? ' optional' : '')}
        style={boxStyle}
      >
      {line}
      </div>
    );
  });

  return(
    <div className="input-boxes">
      {inputBoxes}
    </div>
  );
};
